import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login', // redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'audit-complete',
    loadChildren: () => import('../../pages/audit-complete/audit-complete.module').then(m => m.AuditCompletePageModule)
  },
  {
    path: 'audit-table',
    loadChildren: () => import('../../pages/audit-table/audit-table.module').then(m => m.AuditTablePageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./../../pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'mfa',
    loadChildren: () => import('./../../pages/mfa/mfa.module').then(m => m.MfaPageModule)
  },
  {
    path: 'data-usage-policy',
    loadChildren: () => import('./../../pages/data-usage-policy/data-usage-policy.module').then(m => m.DataUsagePolicyPageModule)
  },
  {
    path: 'eula-message',
    loadChildren: () => import('./../../pages/eula-message/eula-message.module').then(m => m.EulaMessagePageModule)
  },
  {
    path: 'property-details',
    loadChildren: () => import('../../pages/property-details/property-details.module').then(m => m.PropertyDetailsPageModule)
  },
  {
    path: 'property-additional-details',
    loadChildren: () => import('../../pages/property-additional-details/property-additional-details.module').then(m => m.PropertyAdditionalDetailsPageModule)
  },
  {
    path: 'smart-sync',
    loadChildren: () => import('./../../pages/smart-sync/smart-sync.module').then(m => m.SmartSyncPageModule)
  },
  {
    path: 'action-outstanding-list',
    loadChildren: () => import('../../pages/action-outstanding-list/action-outstanding-list.module').then(m => m.ActionOutstandingListPageModule)
  },
  {
    path: 'action-list',
    loadChildren: () => import('./../../pages/action-list/action-list.module').then(m => m.ActionListPageModule)
  },
  {
    path: 'action-complete',
    loadChildren: () => import('./../../pages/action-complete/action-complete.module').then(m => m.ActionCompletePageModule)
  },
  {
    path: 'action-update-progress',
    loadChildren: () => import('./../../pages/action-update-progress/action-update-progress.module').then(m => m.ActionUpdateProgressPageModule)
  },
  {
    path: 'action-email-details',
    loadChildren: () => import('./../../pages/action-email-details/action-email-details.module').then(m => m.ActionEmailDetailsPageModule)
  },
  {
    path: 'action-log-new',
    loadChildren: () => import('../../pages/action-log-new/action-log-new.module').then(m => m.ActionLogNewPageModule)
  },
  {
    path: 'inspections-log-new',
    loadChildren: () => import('../../pages/inspections-log-new/inspections-log-new.module').then(m => m.InspectionsLogNewPageModule)
  },
  {
    path: 'inspections-in-progress',
    loadChildren: () => import('./../../pages/inspections-in-progress/inspections-in-progress.module').then(m => m.InspectionsInProgressPageModule)
  },
  {
    path: 'inspections-completed',
    loadChildren: () => import('./../../pages/inspections-completed/inspections-completed.module').then(m => m.InspectionsCompletedPageModule)
  },
  {
    path: 'inspections-scheduled',
    loadChildren: () => import('./../../pages/inspections-scheduled/inspections-scheduled.module').then(m => m.InspectionsScheduledPageModule)
  },
  {
    path: 'inspection-gallery',
    loadChildren: () => import('./../../pages/inspection-gallery/inspection-gallery.module').then(m => m.InspectionGalleryPageModule)
  },
  {
    path: 'inspections-type-select',
    loadChildren: () => import('./../../pages/inspections-type-select/inspections-type-select.module').then(m => m.InspectionsTypeSelectPageModule)
  },
  {
    path: 'register-list',
    loadChildren: () => import('../../pages/register-list/register-list.module').then(m => m.RegisterListPageModule)
  },
  {
    path: 'register-item-edit',
    loadChildren: () => import('./../../pages/register-item-edit/register-item-edit.module').then(m => m.RegisterItemEditPageModule)
  },
  {
    path: 'register-quick-edit',
    loadChildren: () => import('./../../pages/register-quick-edit/register-quick-edit.module').then(m => m.RegisterQuickEditPageModule)
  },
  {
    path: 'incidents-completed',
    loadChildren: () => import('./../../pages/incidents-completed/incidents-completed.module').then(m => m.IncidentsCompletedPageModule)
  },
  {
    path: 'incidents-in-progress',
    loadChildren: () => import('./../../pages/incidents-in-progress/incidents-in-progress.module').then(m => m.IncidentsInProgressPageModule)
  },
  {
    path: 'incidents-log-new',
    loadChildren: () => import('./../../pages/incidents-log-new/incidents-log-new.module').then(m => m.IncidentsLogNewPageModule)
  },
  {
    path: 'tabs',
    loadChildren: () => import('../../pages/tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'property-selection-sync',
    loadChildren: () => import('../../pages/property-selection-sync/property-selection-sync.module').then(m => m.PropertySelectionSyncPageModule)
  },
  {
    path: 'picture-edit',
    loadChildren: () => import('../../pages/picture-edit/picture-edit.module').then(m => m.PictureEditPageModule)
  },
  {
    path: 'selective-sync',
    loadChildren: () => import('../../pages/selective-sync/selective-sync.module').then(m => m.SelectiveSyncPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
